import { useQueryClient } from '@tanstack/react-query';

import { useGetTile } from '../../../shared/TileView/data';

import TileForm from '../../../shared/TileForm/TileForm.jsx';
import { useTileNavigation } from './CampaignTileView/hooks/useTileNavigation';
import { useScrollToStart } from '../hooks/useScrollToStart';

export const CampaignEditTileForm = ({ tileId, campaignId }) => {
  useScrollToStart();
  const { data: tile, isLoading } = useGetTile({ tileId });
  const queryClient = useQueryClient();

  const {
    isFirstTile,
    isLastTile,
    goToPreview,
    goToNext,
    goToPrevious,
    goBack,
    arrowRightRef,
    arrowLeftRef,
  } = useTileNavigation({ tile, campaignId });

  const onSave = ({ tileId: refetchTileId }) => {
    queryClient.invalidateQueries(['shelfTiles'], { refetchInactive: true });
    queryClient.invalidateQueries(['getTile', refetchTileId]);
  };

  if (isLoading) return null;

  window.Airbo.Utils.trackPage({
    page: 'TileEditForm',
    tile_id: tileId,
    campaign_id: campaignId,
    campaign_name: tile.campaignName,
  });

  return (
    <TileForm
      key={tileId}
      campaignId={campaignId}
      onSave={onSave}
      tile={tile}
      onClose={goBack}
      goToPreview={goToPreview}
      nextTile={goToNext}
      prevTile={goToPrevious}
      isFirstTile={isFirstTile}
      isLastTile={isLastTile}
      arrowRightRef={arrowRightRef}
      arrowLeftRef={arrowLeftRef}
    />
  );
};
